import { Props } from "."

export const mockProps: Props = {
  label: "Password",
  placeholder: "Placeholder",
  helperText: "Helper text",
  error: "Error",
  name: "fieldName",
  className: "max-w-[480px]",
}
